import * as AccountOrders from './AccountOrders';

export default AccountOrders;
